// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './GachaEffectModal.css';

// React Modalで実装
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

const GachaEffectUpload = ({ modalIsOpen, closeModal, shopInfo, setShopInfo, getShop }) => {
  const { t } = useTranslation();
    
  const originals = shopInfo.originalEffectPattern;

  const videoSrc = (rank) => {
    if (shopInfo.effectType <= 1000) {
      return `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-${rank}.mp4`;
    } else {
      if (originals) {
        const original = originals.find(o => o.id === Number(shopInfo.effectType));
        if (original) {
          const item = original.items.find(i => i.rank === rank);
          if (item) {
            return `${process.env.REACT_APP_ASSET_URL}${item.path_with_version}`;
          }
        }
      }
    }
  }

  const [uploads, setUploads] = useState([]);
  const [pattern, setPattern] = useState(1);
  const useProxyUpload = process.env.REACT_APP_USE_PROXY_UPLOAD === 'true';

  const cookies = document.cookie.split('; ');
  const headers = {
    'X-XSRF-TOKEN': decodeURIComponent(cookies.find(c => c.startsWith(process.env.REACT_APP_XSRF_TOKEN))?.split('=')[1]),
    'Bearer': decodeURIComponent(cookies.find(c => c.startsWith('token'))?.split('=')[1]),
  };

  const uploadUrl = async (rank) => {
    const body = new FormData();
    body.append('rank', rank);
    body.append('pattern', pattern);
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/shop-effect-pattern-upload-url`,
      { method: 'POST', headers, credentials: 'include', body })
      .then(res => res.json())
  }

  const upload = async (url, file) =>
    fetch(url, { method: 'PUT', body: file, headers: { 'Content-Type': file.type, } })
      .then(res => {
        if (!res.ok) {
          throw new Error(`${res.status}: ${res.statusText}`);
        }
        return url;
      });

  const uploadViaProxy = async (rank, uploadItem) => {
    const body = new FormData();
    body.append('pattern', pattern);
    body.append('rank', rank);
    body.append('file', uploadItem.file);
    body.append('has_audio', uploadItem.hasAudio ? 1 : 0);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/shop-effect-pattern-upload`,
      { method: 'POST', headers, credentials: 'include', body }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || `${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  const updateEffectPattern = async (items) => {
    const body = new FormData();
    body.append('pattern', pattern);
    items.forEach((i, index) => {
      body.append(`items[${index}][rank]`, i.rank);
      body.append(`items[${index}][path]`, i.path);
      body.append(`items[${index}][has_audio]`, i.hasAudio === true ? 1 : 0);
    });
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/update-effect-pattern`,
      { method: 'POST', headers, credentials: 'include', body })
      .then(res => res.json())
  }

  const updateEffectPatternItem = async (items) => {
    const body = new FormData();
    body.append('pattern', pattern);
    items.forEach(i => {
      body.append(`ranks[]`, i.rank);
    });
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/update-effect-pattern-item`,
      { method: 'POST', headers, credentials: 'include', body })
      .then(res => res.json())
  }

  const handleChange = (e) => {
    const reader = new FileReader();
    const file = e.target.files[0];
    const index = e.target.dataset.index;
    reader.readAsDataURL(file);

    reader.onload = function(re) {
      const copied = [...uploads];

      // base64からバイナリに変換
      const arrayBuffer = Uint8Array.from(atob(re.target.result.split(',')[1]), c => c.charCodeAt(0));
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      audioContext.decodeAudioData(arrayBuffer.buffer, (audioBuffer) => {
        const channelData = audioBuffer.getChannelData(0);
        let max = 0, sum = 0;
        for (let i = 0; i < channelData.length; i++) {
          sum += channelData[i] ** 2;  // デシベルにするために二乗和を計算
          max = Math.max(max, Math.abs(channelData[i]));
        }
        const rms = Math.sqrt(sum / channelData.length);
        const meanDecibels = 20 * Math.log10(rms);
        const maxDecibels = 20 * Math.log10(max);

        let hasAudio = false;
        if (meanDecibels > -60 && maxDecibels > -60) {
          hasAudio = true;
        }
        copied[index] = { file, url: re.target.result, hasAudio: hasAudio };
        setUploads(copied);
      });
    };
  };

  const handleUpload = async () => {
    const hasSelection = uploads.some(Boolean);

    if (!hasSelection) {
      alert(t('gacha_effect_upload.error1'))
      return;
    }

    const index2rank = (index) => index + 1;
    const preparedUploads = uploads
      .map((uploadItem, index) => uploadItem ? { ...uploadItem, rank: index2rank(index) } : null)
      .filter(Boolean);

    // アップロードする。
    try {
      const items = await Promise.all(preparedUploads.map(async (uploadItem) => {
        const { rank } = uploadItem;

        if (useProxyUpload) {
          const response = await uploadViaProxy(rank, uploadItem);
          return { rank, path: response.path, hasAudio: response.has_audio ?? uploadItem.hasAudio };
        }

        const url = await uploadUrl(rank);
        await upload(url, uploadItem.file);
        return { rank, path: `/${new URL(url).pathname.split('/').slice(2).join('/')}`, hasAudio: uploadItem.hasAudio };
      }));

      await updateEffectPattern(items);
    } catch (error) {
      console.error(error);
      alert(error.message || t('gacha_effect_upload.error_upload_failed'));
      return;
    }

    setUploads([]);
    getShop();
    closeModal();
  };

  const handlePatternChange = async (e) => {
    const pattern = e.target.value;
    setPattern(pattern);
    
    setUploads([]);
  };


  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="gacha-effect-modal"
        overlayClassName="gacha-effect-modal-overlay"
        contentLabel="Example Modal"
      >
        <div className="gacha-effect-modal-title" id="upload">{t('gacha_effect_upload.title')}</div>
        <div className="gacha-effect-modal-select">
          <select name="gachaEffect" id="gachaEffect" value={pattern} onChange={(e) => setPattern(e.target.value)}>
            <option value="1">{t('gacha_effect_upload.original1')}</option>
            <option value="2">{t('gacha_effect_upload.original2')}</option>
            <option value="3">{t('gacha_effect_upload.original3')}</option>
            <option value="4">{t('gacha_effect_upload.original4')}</option>
            <option value="5">{t('gacha_effect_upload.original5')}</option>
          </select>
        </div>
        <div className="gacha-effect-modal-imgs">
          <div className="gacha-effect-modal-img">
            <video src={uploads[0]?.url} autoPlay muted loop playsInline></video>
            {t('gacha_effect_upload.rank1')}<input className="gacha-effect-modal-form-input" accept="video/*" type="file" data-index="0" onChange={handleChange} />
          </div>
          <div className="gacha-effect-modal-img">
            <video src={uploads[1]?.url} autoPlay muted loop playsInline></video>
            {t('gacha_effect_upload.rank2')}<input className="gacha-effect-modal-form-input" accept="video/*" type="file" data-index="1" onChange={handleChange} />
          </div>
          <div className="gacha-effect-modal-img">
            <video src={uploads[2]?.url} autoPlay muted loop playsInline></video>
            {t('gacha_effect_upload.rank3')}<input className="gacha-effect-modal-form-input" accept="video/*" type="file" data-index="2" onChange={handleChange} />
          </div>
          <div className="gacha-effect-modal-img">
            <video src={uploads[3]?.url} autoPlay muted loop playsInline></video>
            {t('gacha_effect_upload.rank4')}<input className="gacha-effect-modal-form-input" accept="video/*" type="file" data-index="3" onChange={handleChange} />
          </div>
          <div className="clearfix"></div>
        </div>
        <div className="gacha-effect-modal-button">
          <button className="gacha-effect-modal-form-upload-button" onClick={handleUpload}>{t('gacha_effect_upload.upload')}</button><br />
          <button className="gacha-effect-modal-form-upload-button" onClick={closeModal}>{t('gacha_effect_upload.cancel')}</button>
        </div>
      </Modal>
    </>
  );
}

export default GachaEffectUpload;